module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-04.5dc22ae0.png";